var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"content-mod-class":"d-flex","use-header":false}},[_c('x-error',{attrs:{"code":404,"message":_vm.message,"use-redirect-button":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }